<header
    class="lh-header lh-header--gradient"
    role="banner"
    id="horizontalHeader"
>
    <div class="lh-header__container">
        <div class="lh-header__body">
            <div class="lh-header__title-container">
                <h2 class="lh-header__title">
                    <a
                        routerLink="/home"
                        rel="home"
                        class="lh-header__title-link"
                        >Commercial Analytics Lighthouse</a
                    >
                </h2>
            </div>
            <div class="lh-header__nav-container">
                <nav
                    id="nav"
                    class="lh-header__primary-nav"
                    aria-label="Main navigation"
                >
                    <ul
                        class="lh-header__nav-list"
                        role="menubar"
                        id="horizontalMenu"
                    >
                        <li
                            class="lh-header__nav-item"
                            role="menuitem"
                            *ngIf="hasBwRole"
                        >
                            <a
                                class="lh-header__nav-link"
                                routerLink="/base-stock-and-waxes"
                                aria-expanded="false"
                                aria-current="false"
                                aria-label="Home"
                            >
                                Basestock & Waxes
                            </a>
                        </li>
                        <li
                            class="lh-header__nav-item"
                            role="menuitem"
                            *ngIf="hasCogsRole"
                        >
                            <a
                                class="lh-header__nav-link"
                                routerLink="/cogs"
                                aria-expanded="false"
                                aria-current="false"
                                aria-label="Nav item"
                            >
                                COGS
                            </a>
                        </li>
                        <li
                            class="lh-header__nav-item"
                            role="menuitem"
                            *ngIf="hasFinishedLubesRole"
                        >
                            <a
                                class="lh-header__nav-link"
                                routerLink="/fl"
                                aria-expanded="false"
                                aria-current="false"
                                aria-label="Nav item"
                            >
                                Finished Lubes
                            </a>
                        </li>
                    </ul>
                </nav>
                <nav
                    id="global-nav"
                    class="lh-header__user-nav"
                    aria-label="Global navigation"
                >
                    <ul
                        class="lh-header__user-list"
                        style="max-width: none; padding-right: 2.5rem"
                        role="menubar"
                    >
                        <li
                            class="lh-header__user-item lh-header__user-item--right"
                            role="menuitem"
                            style="
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                margin-left: auto;
                            "
                        >
                            <mat-icon>account_circle</mat-icon>
                            <span>{{ userName }}</span>
                            <span
                                style="
                                    font-size: 0.875rem;
                                    opacity: 0.8;
                                    margin-left: 12px;
                                    margin-right: 12px;
                                "
                                >v{{ version }}</span
                            >
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</header>
